import vPaintViewerHook from "./components/VPaintViewer/hook";
import videosPlayersHook from "./components/VVideosPlayers/hook";
import personInfoModal from "@/components/persecution-total-section/components/person-info-modal/hook";
import Vue from "vue";

const requireContext = require.context("./components", true, /index\.vue$/);

requireContext.keys().forEach((filename) => {
  //  只匹配第一层文件夹, 不匹配子级
  if (filename.match(/\/components\//)) return;
  const componentConfig = requireContext(filename);
  Vue.component(
    componentConfig.default.name || componentConfig.name,
    componentConfig.default || componentConfig
  );
});

Vue.prototype.$videoPlayer = videosPlayersHook;
Vue.prototype.$paintViewer = vPaintViewerHook;
Vue.prototype.$personInfoModal = personInfoModal;
